'use strict'

module.exports = {
  ACTIVE_LINK: 'ACTIVE_LINK'
}



// WEBPACK FOOTER //
// ./src/redux/types/activeLink.js